import { render, staticRenderFns } from "./ViewActivityScorm.vue?vue&type=template&id=59c0cccd"
import script from "./ViewActivityScorm.vue?vue&type=script&lang=js"
export * from "./ViewActivityScorm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports